;$(function () {
  'use strict'

  var recommendedPostTitle = document.querySelectorAll('[data-recommended-post-title]')
  var recommendedPostText = document.querySelectorAll('[data-recommended-post-text]')

  if (recommendedPostTitle) {
    for (var i = 0; i < recommendedPostTitle.length; i++) {
      if (recommendedPostTitle[i].clientHeight > 22) {
        recommendedPostText[i].style['-webkit-line-clamp'] = 3
      }
      else {
        recommendedPostText[i].style['-webkit-line-clamp'] = 4
      }
    }
  }
})
